export default (function (_a) {
    var overflow = _a.overflow;
    if (!overflow) {
        return "";
    }
    if (typeof overflow === "string") {
        return "overflow: ".concat(overflow, ";");
    }
    var _b = overflow.vertical, vertical = _b === void 0 ? "" : _b, _c = overflow.horizontal, horizontal = _c === void 0 ? "" : _c;
    return "\n    ".concat(vertical && "overflow-y: ".concat(vertical, ";"), "\n    ").concat(horizontal && "overflow-x: ".concat(horizontal, ";"), "\n  ");
});
